import { defineComponent as _defineComponent } from 'vue'
import { WallColorScheme } from '@padlet/arvo/lib/types'
import { __ } from 'bits/intl'
import { DEFAULT_MAX_GRADE } from 'bits/surface_settings_helper'
import { storeToRefs } from 'pinia'
import { SnackbarNotificationType, useGlobalSnackbarStore } from 'pinia/global_snackbar'
import { useSurfacePermissionsStore } from 'pinia/surface_permissions'
import { useReactionsStore } from 'pinia/surface_reactions'
import { Post, UserId, WallReactionData } from 'types'
import Vue, { computed, defineAsyncComponent, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostReaction',
  props: {
    post: null,
    isReacting: { type: Boolean },
    currentUserId: null,
    reactionData: null,
    colorScheme: null,
    usageContext: null
  },
  setup(__props: any) {

const props = __props as {
  post: Post
  isReacting: boolean
  currentUserId: UserId
  reactionData: WallReactionData
  colorScheme: WallColorScheme
  usageContext: 'postView' | 'postExpandedView'
}

const SurfacePostReactionLike = defineAsyncComponent(() => import('vuecomponents/SurfacePostReactionLike.vue'))
const SurfacePostReactionVote = defineAsyncComponent(() => import('vuecomponents/SurfacePostReactionVote.vue'))
const SurfacePostReactionGrade = defineAsyncComponent(() => import('vuecomponents/SurfacePostReactionGrade.vue'))
const SurfacePostReactionStar = defineAsyncComponent(() => import('vuecomponents/SurfacePostReactionStar.vue'))



const { createReaction, deleteReaction, updateReaction, startEditingReaction } = useReactionsStore()
const { accumulatedReactionsByWishId, originalReactionData, currentReactionData } = storeToRefs(useReactionsStore())
const reactionType = computed(() => props.reactionData.type)
const accumulatedReaction = computed(() => {
  if (
    accumulatedReactionsByWishId.value[props.post.id as number] == null ||
    accumulatedReactionsByWishId.value[props.post.id as number]?.reactionType !== reactionType.value
  ) {
    return {
      sum: 0,
      totalReactionsCount: 0,
    }
  }
  return accumulatedReactionsByWishId.value[props.post.id as number]
})
const maxGrade = computed(
  () => currentReactionData?.value?.max_value ?? originalReactionData?.value?.max_value ?? DEFAULT_MAX_GRADE,
)
const { setSnackbar } = useGlobalSnackbarStore()
const rootElement = ref<Vue | null>(null)
function create(value: number): void {
  if (rootElement.value == null) return
  if (rootElement.value.$el.closest('.surface-post')?.classList.contains('noclick')) {
    // Prevent reaction event when the post is being dragged
    return
  }
  createReaction({ postId: props.post.id as number, value })
}

function update(value: number): void {
  if (rootElement.value == null) return
  if (rootElement.value.$el.closest('.surface-post')?.classList.contains('noclick')) {
    // Prevent reaction event when the post is being dragged
    return
  }
  updateReaction({ postId: props.post.id as number, value })
}

function edit(): void {
  if (rootElement.value == null) return
  if (rootElement.value.$el.closest('.surface-post')?.classList.contains('noclick')) {
    // Prevent reaction event when the post is being dragged
    return
  }
  const { left, top, width } = (rootElement.value?.$el?.parentElement ?? rootElement.value?.$el).getBoundingClientRect()

  startEditingReaction({
    postId: props.post.id as number,
    dropdownLeft: left,
    dropdownTop: top,
    dropdownWidth: width,
  })
}

function deleteExisting(): void {
  if (rootElement.value == null) return
  if (rootElement.value.$el.closest('.surface-post')?.classList.contains('noclick')) {
    // Prevent reaction event when the post is being dragged
    return
  }
  deleteReaction({ postId: props.post.id as number })
}
function showReactionOffNotice(): void {
  const message = __('Reactions have been disabled. Changes are not allowed.')
  setSnackbar({ message, notificationType: SnackbarNotificationType.error })
}
const isPadletColorSchemeDark = computed(() => props.colorScheme === 'dark')
const canReact = storeToRefs(useSurfacePermissionsStore()).isReactable

return { __sfc: true,SurfacePostReactionLike, SurfacePostReactionVote, SurfacePostReactionGrade, SurfacePostReactionStar, props, createReaction, deleteReaction, updateReaction, startEditingReaction, accumulatedReactionsByWishId, originalReactionData, currentReactionData, reactionType, accumulatedReaction, maxGrade, setSnackbar, rootElement, create, update, edit, deleteExisting, showReactionOffNotice, isPadletColorSchemeDark, canReact }
}

})